import './validatorSetup';
import './findDOMNodePolyfill';
import React from 'react';
import { createRoot } from 'react-dom/client';
import axios from './axios';
import App from './App';
import setAuthToken from './authToken';
import { removeAuthUser, setAuthUser } from './actions';
import { unregister as unregisterServiceWorker } from './registerServiceWorker';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import { store } from './store';
import './index.css';

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.data) {
      const data = JSON.parse(JSON.stringify(error.response.data));
      if (data && data.detail === 'Invalid token.') {
        removeAuthUser();
      }
    }
    throw error;
  },
);

if (localStorage.token && localStorage.user) {
  setAuthToken(localStorage.token);
  setAuthUser(JSON.stringify(localStorage.getItem('user')));
} else {
  removeAuthUser();
}

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <I18nextProvider i18n={i18n}>
    <App store={store} />
  </I18nextProvider>,
);

unregisterServiceWorker();

export default axios;
